import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';
import { baseTableFilter, buildQueryString } from 'utils/general';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
};

export const getAllUser = createAsyncThunk('user/getAllUser', async (filter, { rejectWithValue }) => {
	try {
		const queryData = buildQueryString({
			search: filter.search,
			city: filter.city,
			startDate: filter.startDate,
			endDate: filter.endDate,
			isActive: filter.isActive?.toString(),
			hasMobile: filter.hasMobile?.toString(),
			authSource: filter.authSource,
			isMobileVerified: filter.isMobileVerified?.toString(),
			platform: filter.platform,
			targetEmail: filter.targetEmail,
		});

		const response = await axiosInstance.get(
			`/users?sortBy=${filter?.sortBy ?? baseTableFilter.sortBy}&page=${filter?.page ?? baseTableFilter.page ?? 1}&limit=${filter?.limit ?? baseTableFilter.limit}${queryData ? '&' + queryData : ''}`,
		);

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error');
	}
});

export const getAllUsersCities = createAsyncThunk('user/getAllUsersCities', async (filter, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.get(`/users/cities`);

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error');
	}
});

export const getUserById = createAsyncThunk('user/getUserById', async (id, { rejectWithValue }) => {
	console.log('id', id)
	try {
		const response = await axiosInstance.get(`/users/${id}`);
		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error');
	}
});

export const deleteUser = createAsyncThunk('user/deleteUser', async (id, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.delete(`/users/${id}`);
		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error');
	}
});

export const editUser = createAsyncThunk('user/editUser', async ({ data, userId }, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.patch(`/users/${userId}`, data);
		console.log(response, 'response..');

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err || 'Error');
	}
});

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		showLoading: (state) => {
			state.loading = true;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllUser.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllUser.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllUser.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(getAllUsersCities.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllUsersCities.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllUsersCities.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(getUserById.pending, (state) => {
				state.loading = true;
			})
			.addCase(getUserById.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getUserById.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(deleteUser.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteUser.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(deleteUser.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			});
	},
});

export const { showLoading } = userSlice.actions;

export default userSlice.reducer;
